<section class="container">
  <div class="header-wrapper">
    <h1>Passport Overview</h1>
  </div>
  <div class="content-wrapper">
    @if (tenantDetails) {
        <form>
            <div>
                <mat-form-field>
                    <mat-label>Client Id</mat-label>
                    <input matInput type="text" disabled [(ngModel)]="tenantDetails.clientId" name="clientId" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field>
                    <input matInput type="text" disabled [(ngModel)]="tenantDetails.clientSecret" name="clientSecret"/> 
                </mat-form-field>
            </div>
        </form>
    }
  </div>
</section>
